<template>
<div>
<paged-table :on-request-data="onRequestData" :refresh="refresh" :layout="layout"
      :page-size="pageSize" ref="table" :isAddPageToRouter="isAddPageToRouter"
      :isOutside="isOutside" :initialPage="initialPage" :page-sizes="pageSizes"
      :showPagination="showPagination" :totalSize="totalSize" @select="select"
      :onRequestCount="onRequestCount" @selectAll="selectAll" @size-change="sizeChange"
      @handleCurrentChange="handleCurrentChange" :current-page="current_page">
    <slot/>
</paged-table>
</div>
</template>
<script>
import { PagedTable } from 'wt-ui/pc'
export default {
  name: 'wt-paged-table',
  components: {
    'paged-table': PagedTable
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  props: {
    onRequestData: {
      type: Function
    },
    onRequestCount: {
      type: Function
    },
    // 第一次渲染时的初始页
    initialPage: {
      type: Number,
      default: 0
    },
    totalSize: {
      type: Number
    },
    pageSize: {
      type: Number,
      default: 20
    },
    // 如果为true，则组件在mount后会自动进行一次加载
    refresh: {
      type: Boolean,
      default: false
    },
    // 是否将页码加到页面连接中
    isAddPageToRouter: {
      type: Boolean,
      default: false
    },
    showPagination: {
      type: Boolean,
      default: true
    },
    data: {
      // 初始数据,选填，一般配合数据持久化使用，在页面刷新后，立即通过data传入数据，可立即渲染出列表
      type: Array
    },
    layout: {
      type: String,
      default: 'total, prev, pager, next,jumper'
    },
    currentPage: {
      type: Number,
      default: 0
    },
    pagerCount: {
      type: Number,
      default: 7
    },
    paegLocation: {
      type: String,
      default: 'center'
    },
    isOutside: {// 是否外部默认调用一次列表函数
      type: Boolean,
      default: false
    },
    background: {
      type: Boolean,
      default: false
    },
    pageSizes: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      current_page: this.currentPage
    }
  },
  watch: {
    currentPage (val) {
      this.current_page = val
    }
  },
  methods: {
    handleCurrentChange (currentPage) {
      this.$emit('handleCurrentChange', currentPage)
    },
    sizeChange (val) {
      this.$emit('size-change', val)
      this.$refs.table.lodeRequestData()
    },
    select (row) {
      this.$emit('select', row)
    },
    selectAll (rows) {
      this.$emit('selectAll', rows)
    },
    showReTry () {
      this.$refs.table.showReTry()
    },
    load () {
      this.$refs.table.load()
    },
    resetPage () {
      this.$refs.table.resetPage()
    }
  }
}
</script>
<style lang="less">

</style>
